(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9811],{

/***/ 55038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photography-awards/categories",
      function () {
        return __webpack_require__(64113);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12569);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44087);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80338);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26499);






var Awards2022CategoriesPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var data = (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .useQuerySubscription */ .L)(subscription).data;
    if (!data) return null;
    var categories = data.categories, infoSection = data.infoSection, partners = data.partners, faqs = data.faqs, seo = data.seo, allowSubmissions = data.allowSubmissions;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .AwardsLayout */ .Wy, {
        preview: preview,
        allowSubmissions: allowSubmissions,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .HJ, {
                children: [
                    (0,react_datocms__WEBPACK_IMPORTED_MODULE_4__/* .renderMetaTags */ .y)(seo),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Categories and Prizes for the Narrative International Photography Awards | Narrative"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "awards-categories pt-28 lg:pt-50 pb-25 lg:pb-30",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full max-w-[1232px] px-[20px] mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-48 leading-[107%] mb-8 lg:text-70 lg:mb-12",
                            children: [
                                "Categories",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " and Prizes"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-x-5 md:gap-y-25 gap-y-18",
                            children: categories.map(function(param) {
                                var title = param.title, slug = param.slug, text = param.text, image = param.image, group = param.group, allowCategorySubmission = param.allowSubmission;
                                var groupCategories = categories.filter(function(category) {
                                    return category.group === group;
                                });
                                var isFistOccurrenceOfCategory = groupCategories[0].slug === slug;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                    className: "flex flex-col scroll-mt-20 lg:scroll-mt-24"
                                }, isFistOccurrenceOfCategory && {
                                    id: group.toLowerCase().replace(/\s+/g, "-").replace(/[.,/'#!$%^&*;:{}=\_`~()]/g, "")
                                }), {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-[76px]",
                                            children: isFistOccurrenceOfCategory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-34 leading-tighter mb-8 lg:text-40",
                                                children: group
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "aspect-w-12 aspect-h-7 mb-8.5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                                                data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, image.responsiveImage),
                                                layout: "fill",
                                                objectFit: "cover"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-h3 leading-tighter mb-4",
                                            children: group === title ? title : "".concat(group, ": ").concat(title)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .HtmlToElement */ .Eu, {
                                            className: "prose flex-1 leading-normal mb-5",
                                            children: text
                                        }),
                                        allowSubmissions && allowCategorySubmission && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .ArrowAnchorButton */ .v_, {
                                            href: "/".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .ROUTES.AWARDS.ENTER.SLUG */ .Z6.AWARDS.ENTER.SLUG, "?category=").concat(slug),
                                            variant: "primary",
                                            children: [
                                                "Submit: ",
                                                title.toLowerCase()
                                            ]
                                        })
                                    ]
                                }), slug);
                            })
                        })
                    ]
                })
            }),
            infoSection && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .AwardsSection */ .W0, {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 right-0 bottom-0 left-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                            data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, infoSection.backgroundImage.responsiveImage),
                            layout: "fill",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                        className: "py-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-36",
                                        children: infoSection.leadLine
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-70 font-semibold leading-tighter mb-2",
                                        children: infoSection.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .HtmlToElement */ .Eu, {
                                        className: "prose leading-normal max-w-[500px]",
                                        children: infoSection.description
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            partners && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .AwardsSection */ .W0, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .HorizontalRule */ .bo, {
                            className: "mb-6"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-40 leading-tighter mb-12",
                            children: "Thank you to our awards partners"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-3",
                            children: partners.map(function(param, i) {
                                var heading = param.heading, text = param.text, image = param.image;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "aspect-w-14 aspect-h-8 mb-8 bg-[#1b1b1b]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                                                usePlaceholder: false,
                                                data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, image.responsiveImage),
                                                style: {
                                                    position: "absolute",
                                                    inset: "50% auto auto 50%",
                                                    height: "auto",
                                                    maxWidth: "52%",
                                                    transform: "translate(-50%, -50%)"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .HtmlToElement */ .Eu, {
                                            element: "h3",
                                            className: "text-h3 leading-tighter mb-5",
                                            children: heading
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .HtmlToElement */ .Eu, {
                                            className: "prose leading-normal",
                                            children: text
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            }),
            faqs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .FaqsSection */ .kW, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, faqs))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Awards2022CategoriesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(55038); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);